import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/faq": [12],
		"/image-optimization": [13],
		"/licensable-badge-checker": [14],
		"/metadata-viewer": [15],
		"/privacy": [16],
		"/tos": [17],
		"/[lang]": [4,[2]],
		"/[lang]/faq": [5,[2]],
		"/[lang]/image-optimization": [6,[2]],
		"/[lang]/licensable-badge-checker": [7,[2]],
		"/[lang]/metadata-viewer": [8,[2]],
		"/[lang]/privacy": [9,[2]],
		"/[lang]/tos": [10,[2]],
		"/[lang]/unilink": [11,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';